/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsFromJSON, InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsToJSON, } from './InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4Variants';
/**
 * Check if a given object implements the InternalAdminReactionsEmojiDefinitionResponseV4 interface.
 */
export function instanceOfInternalAdminReactionsEmojiDefinitionResponseV4(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('shortcode' in value) || value['shortcode'] === undefined)
        return false;
    if (!('unicode' in value) || value['unicode'] === undefined)
        return false;
    if (!('enabled' in value) || value['enabled'] === undefined)
        return false;
    if (!('skinToneAllowed' in value) || value['skinToneAllowed'] === undefined)
        return false;
    if (!('rowOrder' in value) || value['rowOrder'] === undefined)
        return false;
    return true;
}
export function InternalAdminReactionsEmojiDefinitionResponseV4FromJSON(json) {
    return InternalAdminReactionsEmojiDefinitionResponseV4FromJSONTyped(json, false);
}
export function InternalAdminReactionsEmojiDefinitionResponseV4FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'shortcode': json['shortcode'],
        'unicode': json['unicode'],
        'enabled': json['enabled'],
        'skinToneAllowed': json['skin_tone_allowed'],
        'rowOrder': json['row_order'],
        'variants': json['variants'] == null ? undefined : InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsFromJSON(json['variants']),
    };
}
export function InternalAdminReactionsEmojiDefinitionResponseV4ToJSON(json) {
    return InternalAdminReactionsEmojiDefinitionResponseV4ToJSONTyped(json, false);
}
export function InternalAdminReactionsEmojiDefinitionResponseV4ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'shortcode': value['shortcode'],
        'unicode': value['unicode'],
        'enabled': value['enabled'],
        'skin_tone_allowed': value['skinToneAllowed'],
        'row_order': value['rowOrder'],
        'variants': InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsToJSON(value['variants']),
    };
}
